import { render, staticRenderFns } from "./SysCheckRuleTestModal.vue?vue&type=template&id=48930bb6&scoped=true"
import script from "./SysCheckRuleTestModal.vue?vue&type=script&lang=js"
export * from "./SysCheckRuleTestModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48930bb6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48930bb6')) {
      api.createRecord('48930bb6', component.options)
    } else {
      api.reload('48930bb6', component.options)
    }
    module.hot.accept("./SysCheckRuleTestModal.vue?vue&type=template&id=48930bb6&scoped=true", function () {
      api.rerender('48930bb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/modules/SysCheckRuleTestModal.vue"
export default component.exports